// extracted by mini-css-extract-plugin
export default {"contractsPage":"contracts_contractsPage","table":"contracts_table","downloadCol":"contracts_downloadCol","document":"contracts_document"};